var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.9394,
    height: 33.9394,
    transform: "translate(0.296875)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7318 19.9593C11.9414 19.9593 10.6016 19.785 10.5415 19.779L10.7758 17.9947C10.7758 17.9947 12.1757 18.1689 13.948 18.1569L13.9661 19.9593H13.7318V19.9593Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 24.4833V26.2857H9.80841C8.81108 26.2857 8 25.4806 8 24.4833V7H9.8024V24.4833H26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 21.3351C15.8646 20.6622 16.6156 19.3765 16.9761 17.502L17.0061 17.3578C17.3906 15.3692 18.5562 9.30707 25.916 9.30707V11.1095C20.2805 11.1095 19.2351 15.3692 18.8265 17.4539C19.3432 17.2797 19.7938 17.0634 20.1663 16.8111L21.1697 18.3071C20.4126 18.8177 19.4454 19.2083 18.3038 19.4846C17.7391 21.0347 16.8559 22.1762 15.6663 22.8912C14.6149 23.522 13.5154 23.6902 12.6323 23.6902C11.6409 23.6902 10.932 23.474 10.8779 23.4559L11.4066 21.7316C11.4066 21.7316 13.2211 22.2603 14.7531 21.3351V21.3351Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.269 14.4379C22.99 13.4887 23.8491 12.8999 25.9159 12.8999V14.7023C24.3298 14.7023 24.0234 15.0988 23.705 15.5254L22.269 14.4379Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19.2857,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGf);
export default __webpack_public_path__ + "static/media/gf.b3442dcc65e8739ed236210bf7c76f29.svg";
export { ForwardRef as ReactComponent };